import { Entity } from '@backstage/catalog-model';
import { DateTime } from 'luxon';

// The backend module catalogModuleCommitActivity writes these annotations. Keep the keys in step with it.
export const lastCommitAnnotation = 'journey.travel/last-commit-at';
export const commits30DaysAnnotation = 'journey.travel/commits-30-days';
export const commits12MonthsAnnotation = 'journey.travel/commits-12-months';

const countFormat = new Intl.NumberFormat('en-GB');

export const annotationOf = ({
  entity,
  annotation,
}: {
  entity: Entity;
  annotation: string;
}) => entity.metadata.annotations?.[annotation];

export const formatCount = (count: string) => countFormat.format(Number(count));

export const LastCommit = ({ entity }: { entity: Entity }) => {
  const committedAt = annotationOf({
    entity,
    annotation: lastCommitAnnotation,
  });
  if (!committedAt) {
    return null;
  }
  const date = DateTime.fromISO(committedAt);
  return (
    <span title={date.toLocaleString(DateTime.DATETIME_MED)}>
      {date.toRelative()}
    </span>
  );
};

// The backend writes both counts whenever it has activity. Only the last commit can be missing.
export const hasCommitActivity = (entity: Entity) =>
  annotationOf({ entity, annotation: commits30DaysAnnotation }) !== undefined;
